<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">Users Age</p>

    <small class="mb-2 d-inline-block">Results shown are from current data only, date range applied does not change results</small>

    <section class="call-stats__items" v-if="!loading">
      <p cy="pie-title" class="text-center title-divider top-divider font-weight-bold">
        Age breakdown of verified {{additionalUser ? 'additional' : ''}}
        users
      </p>

      <p cy="total-users" class="text-right brand-color font-weight-bold">
        Total {{additionalUser ? 'additional' : ''}} Users: {{stats.total}}
      </p>

      <apexchart class="pie-custom" v-if="stats.total > 0"  :options="chart.options" type="pie" :series="chart.series.data"></apexchart>
      <p v-else>
        No data for {{additionalUser ? 'additional' : ''}} Users
      </p>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import axios from 'axios';
  import Vue from 'vue';
  import { mapState } from 'vuex';
  import BiStatsService from '../../../services/BiStatsService';
  import HelperService from '../../../services/HelperService';

  export default {
    components: {},
    props: {
      filters: {
        required: true,
        type: Object,
      },
      additionalUser: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        curReq: null,
        helperService: new HelperService(),
        loading: true,
        stats: [],
        chart: {
          series: {
            name: 'Visitor users',
            data: [],
          },
          options: {
            colors: [],
            labels: [],
          },
        },
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getStats();
        },
        deep: true,
      },
    },
    mounted() {
      this.chart.options.colors = this.helperService.getChartColors();
      this.getStats();
    },
    methods: {
      getStats() {
        this.loading = true;

        if (this.additionalUser) {
          this.getAdditionalVisitorUsersStats();
        } else {
          this.getVisitorUsersStats();
        }
      },
      getVisitorUsersStats() {
        if (this.curReq) {
          this.curReq.cancel('cancelled');
        }

        this.curReq = BiStatsService.createCancelToken();

        BiStatsService.getVisitorCount(this.filters, this.curReq.token).then(res => {
          this.stats = res.data;
          this.setUpChartData(this.stats);
          this.curReq = null; // mark the request as complete
        }).catch(err => {
          // console.log('could not get visitor users stats', err);
          if (!axios.isCancel(err)) {
            this.$toast.error('Could not get users stats, please refresh and try again', {
              toastClassName: ['toast-std', 'warning-toast'],
            });
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      getAdditionalVisitorUsersStats() {
        BiStatsService.getAdditionalVisitorCount(this.filters).then(res => {
          this.stats = res.data;
          this.setUpChartData(this.stats);
        }).catch(err => {
          console.log('could not get additional users stats', err);
          this.$toast.error('Could not get additional visitor users stats, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      setUpChartData(ageData) {
        const ageDataNew = JSON.parse(JSON.stringify(ageData)); // deep clone

        this.chart.series.data = [];
        this.chart.options.labels = [];

        if (!this.additionalUser) {
          Vue.delete(ageDataNew.ages, 'under_18'); // delete if not additional
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(ageDataNew.ages)) {
          this.chart.series.data.push(value);
          this.chart.options.labels.push(this.formatAgeLabel(key));
        }
      },
      formatAgeLabel(text) {
        return text.replace(/_/g, ' ');
      },
    },
  };
</script>
